import { render, staticRenderFns } from "./orderTable.vue?vue&type=template&id=3fb17b00&scoped=true&"
import script from "./orderTable.vue?vue&type=script&lang=js&"
export * from "./orderTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fb17b00",
  null
  
)

export default component.exports